<template>
  <div class="box-customer">
    <div class="box-title">
      <div class="text">
        Thông tin cá nhân
      </div>
    </div>
    <div class="content-box">
      <b-form
        @submit.prevent="onUpdateInfoInforInvestment()"
        class="mb-4 box"
        id="uploadImage"
      >
        <div class="form-group">
          <label for="">
            Họ và Tên (được in trên CMND / CCCD / Hộ Chiếu)
          </label>
          <input
            v-if="InfoInvestment.status !== -1"
            type="text"
            :value="InfoInvestment.fullname"
            class="form-control"
            readonly
            style="background: transparent"
          />
          <input
            v-else
            type="text"
            v-model="infoInvestment.fullname"
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.infoInvestment.fullname.$error,
            }"
          />
          <div
            v-if="submitted && !$v.infoInvestment.fullname.required"
            class="invalid-feedback"
          >
            Vui lòng điền thông tin trường này , đây là trường bắt buộc
          </div>
        </div>
        <div class="form-group mt-4">
          <label for="">Số (CMND / CCCD / Hộ Chiếu)</label>
          <input
            v-if="InfoInvestment.status !== -1"
            type="text"
            :value="InfoInvestment.passport"
            class="form-control"
            readonly
            style="background: transparent"
          />
          <input
            v-else
            type="text"
            v-model="infoInvestment.passport"
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.infoInvestment.passport.$error,
            }"
          />
          <div
            v-if="submitted && !$v.infoInvestment.passport.required"
            class="invalid-feedback"
          >
            Vui lòng điền thông tin trường này , đây là trường bắt buộc
          </div>
          <div
            v-if="submitted && !$v.infoInvestment.passport.between"
            class="invalid-feedback"
          >
            Đối với CMND là 9 số , CCCD là 12 số , Passport là 7 số và 1 kí tự
          </div>
        </div>
        <div class="form-group mt-4">
          <label for="">
            Ngày Cấp (CMND / CCCD / Hộ Chiếu được in trên CMND / CCCD / Hộ
            Chiếu)
          </label>
          <p class="text-start mb-0">
            <span class="fileSize ">
              *Vui lòng điền đúng định dạng ngày tháng năm của bạn giống trong
              CMND / CCCD.
            </span>
          </p>
          <b-form-input
            readonly
            v-if="InfoInvestment.status !== -1"
            :value="InfoInvestment.dateissuance"
          ></b-form-input>
          <b-form-datepicker
            v-else
            id="Fromdate2"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="vi-VN"
            :hide-header="true"
            type="date"
            v-model="infoInvestment.dateissuance"
            placeholder="Chọn ngày cấp..."
          ></b-form-datepicker>
          <div
            v-if="submitted && !$v.infoInvestment.dateissuance.required"
            class="invalid-feedback"
          >
            Vui lòng điền thông tin trường này , đây là trường bắt buộc
          </div>
        </div>
        <div class="form-group mt-4">
          <label for="">
            Nơi Cấp (CMND / CCCD / Hộ Chiếu được in trên CMND / CCCD / Hộ Chiếu)
          </label>
          <input
            v-if="InfoInvestment.status !== -1"
            type="text"
            :value="InfoInvestment.whereissuance"
            class="form-control"
            readonly
            style="background: transparent"
          />
          <input
            v-else
            type="text"
            v-model="infoInvestment.whereissuance"
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.infoInvestment.whereissuance.$error,
            }"
          />
          <div
            v-if="submitted && !$v.infoInvestment.whereissuance.required"
            class="invalid-feedback"
          >
            Vui lòng điền thông tin trường này , đây là trường bắt buộc
          </div>
        </div>
        <div class="form-group mt-4">
          <label for="">
            Ngày Sinh (được in trên CMND / CCCD / Hộ Chiếu)
          </label>
          <p class="text-start mb-0">
            <span class="fileSize ">
              *Vui lòng điền đúng định dạng ngày tháng năm sinh của bạn giống
              trong CMND / CCCD / Hộ Chiếu.
            </span>
          </p>
          <div class="input-birthday">
            <div class="box-dt box-ip">
              <b-form-input
                placeholder="Ngày Sinh"
                type="number"
                v-model.number="infoInvestment.day"
                :readonly="infoInvestment.dateofbirth.lenth > 2"
              ></b-form-input>
              <div
                v-if="submitted && !$v.infoInvestment.day.required"
                class="invalid-feedback"
              >
                Vui lòng điền thông tin trường này , đây là trường bắt buộc
              </div>
              <div
                v-if="submitted && !$v.infoInvestment.day.minValue"
                class="invalid-feedback"
              >
                Ngày bắt đầu từ 1
              </div>
              <div
                v-if="submitted && !$v.infoInvestment.day.maxValue"
                class="invalid-feedback"
              >
                Ngày kết thúc tối đa là 31
              </div>
            </div>
            <div class="box-m box-ip">
              <b-form-input
                placeholder="Tháng Sinh"
                type="number"
                v-model.number="infoInvestment.month"
                :readonly="infoInvestment.dateofbirth.lenth > 2"
              ></b-form-input>
              <div
                v-if="submitted && !$v.infoInvestment.month.required"
                class="invalid-feedback"
              >
                Vui lòng điền thông tin trường này , đây là trường bắt buộc
              </div>
              <div
                v-if="submitted && !$v.infoInvestment.month.minValue"
                class="invalid-feedback"
              >
                Tháng bắt đầu từ 1
              </div>
              <div
                v-if="submitted && !$v.infoInvestment.month.maxValue"
                class="invalid-feedback"
              >
                Tháng kết thúc tối đa là 12
              </div>
            </div>
            <div class="box-y box-ip">
              <b-form-input
                placeholder="Năm Sinh"
                v-model.number="infoInvestment.year"
                type="number"
                :readonly="infoInvestment.dateofbirth.lenth > 2"
              ></b-form-input>
              <div
                v-if="submitted && !$v.infoInvestment.year.required"
                class="invalid-feedback"
              >
                Vui lòng điền thông tin trường này , đây là trường bắt buộc
              </div>
              <div
                v-if="submitted && !$v.infoInvestment.year.minValue"
                class="invalid-feedback"
              >
                Năm bắt đầu từ 1900
              </div>
              <div
                v-if="submitted && !$v.infoInvestment.year.maxValue"
                class="invalid-feedback"
              >
                Năm tối đa là hiện tại
              </div>
            </div>
          </div>
          <template v-if="false">
            <b-form-input
              readonly
              v-if="InfoInvestment.status !== -1"
              :value="InfoInvestment.dateofbirth"
            ></b-form-input>
            <b-form-datepicker
              v-else
              id="Fromdate3"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              locale="vi-VN"
              :hide-header="true"
              type="date"
              v-model="infoInvestment.dateofbirth"
              placeholder="Chọn ngày cấp..."
            ></b-form-datepicker>
            <div
              v-if="submitted && !$v.infoInvestment.dateofbirth.required"
              class="invalid-feedback"
            >
              Vui lòng điền thông tin trường này , đây là trường bắt buộc
            </div>
          </template>
        </div>
        <div class="form-group mt-4">
          <label for="">
            Giới Tính (được in trên CMND / CCCD / Hộ Chiếu)
          </label>
          <p class="text-start mb-0">
            <span class="fileSize ">
              *Vui lòng chọn đúng giới tính của bạn giống trong CMND / CCCD / Hộ
              Chiếu.
            </span>
          </p>
          <b-form-radio-group
            id="radio-group-1"
            v-model="InfoInvestment.gender"
            :options="genderList"
            v-if="InfoInvestment.status !== -1"
            name="radio-options"
            disabled
          ></b-form-radio-group>
          <b-form-radio-group
            v-else
            id="radio-group-2"
            v-model="infoInvestment.gender"
            :options="genderList"
            name="radio-options"
            :class="{
              'is-invalid': submitted && $v.infoInvestment.gender.$error,
            }"
          ></b-form-radio-group>
          <div
            v-if="submitted && !$v.infoInvestment.gender.required"
            class="invalid-feedback"
          >
            Vui lòng điền thông tin trường này , đây là trường bắt buộc
          </div>
        </div>
        <div class="form-group">
          <label for="">
            Quốc Tịch (được in trên CMND / CCCD / Hộ Chiếu)
          </label>
          <input
            v-if="InfoInvestment.status !== -1"
            type="text"
            :value="InfoInvestment.nationality"
            class="form-control"
            readonly
            style="background: transparent"
          />
          <input
            v-else
            type="text"
            v-model="infoInvestment.nationality"
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.infoInvestment.nationality.$error,
            }"
          />
          <div
            v-if="submitted && !$v.infoInvestment.nationality.required"
            class="invalid-feedback"
          >
            Vui lòng điền thông tin trường này , đây là trường bắt buộc
          </div>
        </div>
        <div class="form-group">
          <label for="">
            Địa Chỉ Thường Trú (được in trên CMND / CCCD / Hộ Chiếu)
          </label>
          <input
            v-if="InfoInvestment.status !== -1"
            type="text"
            :value="InfoInvestment.address"
            class="form-control"
            readonly
            style="background: transparent"
          />
          <input
            v-else
            type="text"
            v-model="infoInvestment.address"
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.infoInvestment.address.$error,
            }"
          />
          <div
            v-if="submitted && !$v.infoInvestment.address.required"
            class="invalid-feedback"
          >
            Vui lòng điền thông tin trường này , đây là trường bắt buộc
          </div>
        </div>
        <div class="form-group">
          <label for="">
            Số Điện Thoại
          </label>
          <input
            v-if="InfoInvestment.status !== -1"
            type="text"
            :value="InfoInvestment.phone"
            class="form-control"
            readonly
            style="background: transparent"
          />
          <input
            v-else
            type="text"
            v-model="infoInvestment.phone"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="">
            Mã Số Thuế (không bắt buộc)
          </label>
          <input
            v-if="InfoInvestment.status !== -1"
            type="text"
            :value="InfoInvestment.taxcode"
            class="form-control"
            readonly
            style="background: transparent"
          />
          <input
            v-else
            type="text"
            v-model="infoInvestment.taxcode"
            class="form-control"
          />
        </div>
        <div
          class="d-flex justify-content-center align-items-center submit flex-column mt-5"
        >
          <b-button
            variant="primary"
            v-if="InfoInvestment.status == -1"
            class="buttonSubmit"
            type="submit"
          >
            Xác Nhận
          </b-button>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { required, minValue, maxValue } from 'vuelidate/lib/validators';

  export default {
    data() {
      return {
        infoInvestment: {
          passport: '',
          dateissuance: '',
          whereissuance: '',
          fullname: '',
          dateofbirth: '',
          gender: '',
          nationality: '',
          address: '',
          phone: '',
          taxcode: '',
          day: 1,
          month: 1,
          year: 1990,
        },

        submitted: false,
        genderList: [
          {
            value: 'Nam',
            text: 'Nam',
          },
          {
            value: 'Nư',
            text: 'Nữ',
          },
        ],
      };
    },
    methods: {
      onUpdateInfoInforInvestment() {
        // if(this.infoInvestment.gender === ""){
        //   this.$toastr.e('Giới tính không được để trống', 'Thất bại');
        //   return;
        // }
        this.submitted = true;
        this.$v.$touch();
        console.log(this.$v.infoInvestment);
        if (this.$v.infoInvestment.$invalid) {
          return;
        }
        const { day, month, year } = this.infoInvestment;
        this.infoInvestment.dateofbirth = `${day}-${month}-${year}`;
        this.$store.dispatch(
          'user/req_postInforInvestment',
          this.infoInvestment
        );
      },
    },
    computed: {
      ...mapGetters({
        InfoInvestment: 'user/InfoInvestment',
      }),
    },
    validations: {
      infoInvestment: {
        fullname: {
          required,
        },
        passport: {
          required,
          between(value) {
            const length = value.length;
            return length >= 8 && length <= 12;
          },
        },
        dateissuance: {
          required,
        },
        whereissuance: {
          required,
        },
        gender: {
          required,
        },
        nationality: {
          required,
        },
        address: {
          required,
        },
        day: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(31),
        },
        month: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(12),
        },
        year: {
          required,
          minValue: minValue(1900),
          maxValue: maxValue(new Date().getFullYear()),
        },
      },
    },
    watch: {
      InfoInvestment: {
        handler(newVal) {
          if (newVal.dateofbirth) {
            const arrD = newVal.dateofbirth.split('-');
            console.log(arrD);
            this.infoInvestment.day = parseInt(arrD[2]);
            this.infoInvestment.month = parseInt(arrD[1]);
            this.infoInvestment.year = parseInt(arrD[0]);
          }
        },
      },
    },
    mounted() {
      if (this.InfoInvestment.dateofbirth) {
        const arrD = this.InfoInvestment.dateofbirth.split('-');
        this.infoInvestment.day = parseInt(arrD[2]);
        this.infoInvestment.month = parseInt(arrD[1]);
        this.infoInvestment.year = parseInt(arrD[0]);
      }
    },
    created() {
      this.$store.dispatch('user/req_getInforInvestment');
      this.unsubscribe = this.$store.subscribe((mutation) => {
        // eslint-disable-next-line default-case
        switch (mutation.type) {
          case 'user/UPDATE_INFO_INVESTMENT_SUCCESS':
            this.$bvModal.hide('modal-updateKYC');
            break;
        }
      });
    },
    beforeDestroy() {
      this.unsubscribe();
    },
  };
</script>
<style lang="scss">
  #radio-group-1,
  #radio-group-2 {
    display: flex;
    max-width: 300px;
    margin: 20px 0 0;
    justify-content: space-between;
    align-items: center;
    .custom-control {
      display: flex;
      justify-content: space-between;

      input {
        margin-right: 10px;
        width: 25px;
        background-color: #008afd;
        height: 25px;
      }
      label {
        font-size: 19px;
      }
    }
  }
  #Fromdate2 {
    box-shadow: unset;
  }
  .box-customer {
    padding: 2px 5px 0px 0px !important;
    .form-control {
      color: #000;
      background-color: #ffff;
    }
    .dropdown-menu {
      color: #000;
      background-color: #fff;
      .btn,
      .text-muted {
        color: #000 !important;
        background: #fff !important;
        border: 0 !important;
      }
      .btn {
        width: 30px;
        height: 30px;
        margin: 1px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .box-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 40px;
    padding: 0 1.25rem;
    background-color: #ffff;
    border-radius: 10px 10px 10px 10px;
    box-shadow: 2px 3px 10px 0px rgba(0, 0, 0, 0.305);
    .text {
      color: #000;
      font-weight: 600;
      font-size: 20px;
      text-transform: capitalize;
      .text-warning {
        font-size: clamp(15px, 2vw, 16px);
      }
    }
    .icon {
      cursor: pointer;
      img {
        height: 20px;
        width: auto;
      }
      &.active {
        transform: rotate(180deg);
      }
    }
  }
  .content-box {
    padding: 1.25rem;
    .text-error {
      color: red;
      font-size: 13px;
      font-weight: 700;
      text-transform: capitalize;
    }

    .form-group {
      max-width: 690px;
      margin: 0 auto 10px;
      label {
        font-weight: 600;
        color: #ffff;
        font-size: 16px;
        margin-top: 15px;
      }
      .input-group-text {
        background: transparent;
        padding: 0;
        border: 1px solid #e9ecef;
        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      select,
      input {
        width: 100%;
        border: 1px solid #e9ecef;
        height: 40px;
        font-size: clamp(13px, 1vw, 14.2px);
        font-weight: 600;
        background: #fff !important;
        border-radius: 5px;
        padding-left: 5px;
        color: #000 !important;
        &:focus {
          box-shadow: 0 0 0 1px rgba(56, 169, 73, 45%);
        }
        &::placeholder {
          font-weight: 500;
          font-size: clamp(13px, 1vw, 15px);
        }
      }
    }
    .close {
      color: #fff;
    }
    .removi-img {
      position: absolute;
      top: calc(50% - 15px);
      left: 0;
      right: 0;
      margin: auto;
      background: #f3d91f;
      border: 1px #f3d91f solid;
      border-radius: 5px;
      padding: 7px 20px;
      opacity: 0;
      z-index: 20;
      width: 200px;
      transition: 0.3s;
      transform: translateY(100%);
      color: #000 !important;
    }
    .show-img:hover .removi-img {
      transform: translateY(0);
      opacity: 1;
    }
    .show-img {
      padding: 10px !important;
      height: auto !important;
      position: relative !important;
    }
    .show-img img {
      position: relative;
      z-index: 10;
      max-width: 225px;
    }
    .show-img {
      &:hover {
        &::after {
          background: rgba(0, 0, 0, 0.3);
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          border-radius: 10px;
          height: 100%;
          z-index: 11;
          content: '';
        }
      }
    }
    svg {
      font-size: 30px;
    }
    #uploadImage {
      .avatarEmpty {
        background: #1111111f;
        padding: 45px 0;
        color: #424242;
        border-radius: 10px;
        height: 180px;
        margin-bottom: 23px;
        width: 100%;
        position: relative;
        cursor: pointer;
        text-align: center;

        .fileUpload {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 22;
          outline: none;
          opacity: 0;
        }

        p {
          font-size: 20px;
          font-weight: 500;
          margin-top: 20px;
          margin-bottom: 0;
          color: #fff;
          opacity: 0.8;
        }
      }

      .imgInfo {
        text-align: center;
        margin-bottom: 20px;

        .colorGreen {
          color: #25e69c;
          margin: 0 10px;
        }
      }
    }
    .input-birthday {
      display: flex;
      justify-content: space-between;
      .box-ip {
        flex: 1;
        margin-right: 10px;
        margin-top: 5px;
        .invalid-feedback {
          display: block;
        }
        &:last-child {
          margin-right: 0;
        }
        input {
          text-align: center;
        }
        input[type='number'] {
          -moz-appearance: textfield;
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          /* display: none; <- Crashes Chrome on hover */
          -webkit-appearance: none;
          margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
        }
      }
    }
  }
</style>
